module.exports = __webpack_public_path__ + "Linda Chan-31a968db.png";